
import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-black/90 backdrop-blur-md' : 'bg-transparent'
    }`}>
      <div className="container-max">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/1690b37a69531419192e3d0930ef8929.jpeg" 
              alt="Clear Aligner Box Logo" 
              className="h-16 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('hero')}
              className="text-white hover:text-[#D4AF37] transition-colors duration-300 font-medium whitespace-nowrap"
            >
              Ana Sayfa
            </button>
            <button 
              onClick={() => scrollToSection('why-transparent')}
              className="text-white hover:text-[#D4AF37] transition-colors duration-300 font-medium whitespace-nowrap"
            >
              Neden Şeffaf Plak?
            </button>
            <button 
              onClick={() => scrollToSection('instructions')}
              className="text-white hover:text-[#D4AF37] transition-colors duration-300 font-medium whitespace-nowrap"
            >
              Kullanım Talimatları
            </button>
            <button 
              onClick={() => scrollToSection('cleaning-guide')}
              className="text-white hover:text-[#D4AF37] transition-colors duration-300 font-medium whitespace-nowrap"
            >
              Temizlik Rehberi
            </button>
            <button 
              onClick={() => scrollToSection('faq')}
              className="text-white hover:text-[#D4AF37] transition-colors duration-300 font-medium whitespace-nowrap"
            >
              Sık Sorulan Sorular
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-white hover:text-[#D4AF37] transition-colors duration-300 font-medium whitespace-nowrap"
            >
              İletişim
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-white hover:text-[#D4AF37] transition-colors duration-300"
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-black/95 backdrop-blur-md border-t border-[#D4AF37]/20">
            <nav className="py-4 space-y-2">
              <button 
                onClick={() => scrollToSection('hero')}
                className="block w-full text-left px-4 py-3 text-white hover:text-[#D4AF37] hover:bg-[#D4AF37]/10 transition-all duration-300 font-medium"
              >
                Ana Sayfa
              </button>
              <button 
                onClick={() => scrollToSection('why-transparent')}
                className="block w-full text-left px-4 py-3 text-white hover:text-[#D4AF37] hover:bg-[#D4AF37]/10 transition-all duration-300 font-medium"
              >
                Neden Şeffaf Plak?
              </button>
              <button 
                onClick={() => scrollToSection('instructions')}
                className="block w-full text-left px-4 py-3 text-white hover:text-[#D4AF37] hover:bg-[#D4AF37]/10 transition-all duration-300 font-medium"
              >
                Kullanım Talimatları
              </button>
              <button 
                onClick={() => scrollToSection('cleaning-guide')}
                className="block w-full text-left px-4 py-3 text-white hover:text-[#D4AF37] hover:bg-[#D4AF37]/10 transition-all duration-300 font-medium"
              >
                Temizlik Rehberi
              </button>
              <button 
                onClick={() => scrollToSection('faq')}
                className="block w-full text-left px-4 py-3 text-white hover:text-[#D4AF37] hover:bg-[#D4AF37]/10 transition-all duration-300 font-medium"
              >
                Sık Sorulan Sorular
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="block w-full text-left px-4 py-3 text-white hover:text-[#D4AF37] hover:bg-[#D4AF37]/10 transition-all duration-300 font-medium"
              >
                İletişim
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
